import { Navigate } from 'react-router-dom';
import MainLayout from '../layouts/main';
import { useUser } from '../../hooks/react-query/use-user';
import { getNextRedirectURL } from '../../utils/url';
import RegisterContent from './register-content';

function RegisterPage() {
  const { isAuthenticated } = useUser();
  if (isAuthenticated) return <Navigate replace to={getNextRedirectURL()} />;

  return (
    <MainLayout loginRequired={false} studentRequired={false} title={REGISTER_PAGE_TITLE}>
      <div data-testid='register' className='flex justify-center'>
        <div className='w-full md:w-3/4 lg:w-2/3 xl:w-1/2'>
          <RegisterContent />
        </div>
      </div>
    </MainLayout>
  );
}

export const REGISTER_PAGE_TITLE = 'ثبت نام';

export default RegisterPage;
